export const appPaneNames = [
    'help',
    'tips',
    'support',
    'feedback',
    'getDiagnostics',
    'rolloutOverrides',
    'editor',
    'dictationHelp',
    'addins',
    'chatCopilot',
    'contentPicker',
    'accChecker',
    'myDay',
] as const;

export type AppPaneName = typeof appPaneNames[number];
